import { getRgObjectsOfType as c, RG_TYPE as d } from "@project-rouge/rg-core";
import { getPolygonPerimeter as l } from "../../../geometry-utils/core/index16.js";
const v = (r, n) => {
  let t = 0;
  const o = c(r, d.Building);
  for (const e of o)
    t += f(e, n);
  return t;
};
function f(r, n) {
  const t = r.data.levels.filter((e) => e.levelIndex === n);
  let o = 0;
  for (const e of t) {
    const a = r.children.find((i) => i.type === d.Facade && i.data.levelId === e.uuid);
    if (!a)
      return 0;
    if (e.isRoof) {
      o += e.roofFacadePerimeter ? e.roofFacadePerimeter.reduce((i, s) => i + l(s), 0) * a.size[1] : 0;
      continue;
    }
    !e.geaPolygon || (o += l(e.geaPolygon) * a.size[1]);
  }
  return o;
}
export {
  v as getLevelGrossFacadeArea
};
//# sourceMappingURL=index22.js.map
